export * from './kunden-gruppes-filter.component';
export * from './kunden-gruppes-filter.component.module';